<template>
  <VContent>
    <HomePage v-if="$store.state.loggedin" />
    <SplashPage v-else />
  </VContent>
</template>

<script>


import HomePage from "@/views/home/HomePage";
import SplashPage from "@/views/home/SplashPage";
export default {
  components: {
    SplashPage,
    HomePage
  },
};
</script>
